import { ThemeDefinition } from "vuetify";

const base = {
  background: "#F9F5F2",
  surface: "#FFFFFF",
  navbar: "#07095F",
  brandBlue: "#0004E7",
  primary: "#0004E7",
  lavender: "#C4C5FF",
  mint: "#7BE0A3",
  amber: "#F2C47E",
  coral: "#F57A74",
};

const semantic = {
  primary: base.primary,
  secondary: base.lavender,
  success: base.mint,
  warning: base.amber,
  error: base.coral,
  info: base.lavender,
};

const customTokens = {
  blue: base.brandBlue,
  beige: base.background,
  yellow: "#DFFF9B",
  purple: semantic.secondary,
  orange: "#FF6B2F",
  red: base.coral,
  green: base.mint,
};

const chartPalette = {
  charts0: base.brandBlue,
  charts1: "#7cb5ec",
  charts2: "#434348",
  charts3: "#90ed7d",
  charts4: "#f7a35c",
  charts5: "#8085e9",
  charts6: "#f15c80",
  charts7: "#e4d354",
  charts8: "#2b908f",
  charts9: "#f45b5b",
  charts10: "#91e8e1",
};

const blueScale = {
  "light-blue": base.brandBlue,
  "blue-lighten-1": "#2629ea",
  "blue-lighten-2": "#4c4fee",
  "blue-lighten-3": "#7274f1",
  "blue-lighten-4": "#999af5",
  "blue-lighten-5": "#bfc0f9",
  "blue-darken-1": "#0003c4",
  "blue-darken-2": "#0002a1",
  "blue-darken-3": "#00027f",
  "blue-darken-4": "#00015c",
  "blue-darken-5": "#000139",
};

const beigeScale = {
  "beige-lighten-1": "#f9f6f3",
  "beige-lighten-2": "#faf8f5",
  "beige-lighten-3": "#fbf9f7",
  "beige-lighten-4": "#fcfbf9",
  "beige-lighten-5": "#fdfcfb",
  "beige-darken-1": "#d3d0cd",
  "beige-darken-2": "#aeaba9",
  "beige-darken-3": "#888685",
  "beige-darken-4": "#636260",
  "beige-darken-5": "#3e3d3c",
};

const yellowScale = {
  "yellow-lighten-1": "#e3ffaa",
  "yellow-lighten-2": "#e8ffb9",
  "yellow-lighten-3": "#edffc8",
  "yellow-lighten-4": "#f2ffd7",
  "yellow-lighten-5": "#f7ffe5",
  "yellow-darken-1": "#bdd883",
  "yellow-darken-2": "#9cb26c",
  "yellow-darken-3": "#7a8c55",
  "yellow-darken-4": "#59663e",
  "yellow-darken-5": "#373f26",
};

const purpleScale = {
  "purple-lighten-1": "#cccdff",
  "purple-lighten-2": "#d5d6ff",
  "purple-lighten-3": "#dedfff",
  "purple-lighten-4": "#e7e7ff",
  "purple-lighten-5": "#f0f0ff",
  "purple-darken-1": "#a6a7d8",
  "purple-darken-2": "#8989b2",
  "purple-darken-3": "#6b6c8c",
  "purple-darken-4": "#4e4e66",
  "purple-darken-5": "#31313f",
};

const orangeScale = {
  "orange-lighten-1": "#ff814e",
  "orange-lighten-2": "#ff976d",
  "orange-lighten-3": "#ffad8c",
  "orange-lighten-4": "#ffc3ab",
  "orange-lighten-5": "#ffd9cb",
  "orange-darken-1": "#d85a27",
  "orange-darken-2": "#b24a20",
  "orange-darken-3": "#8c3a19",
  "orange-darken-4": "#662a12",
  "orange-darken-5": "#3f1a0b",
};

export const kaia: ThemeDefinition = {
  dark: false,
  colors: {
    // Layout
    background: base.background,
    surface: base.surface,
    menubg: base.navbar,
    navbarbg: base.navbar,

    // Semantic
    ...semantic,

    // Text
    "on-background": "#000000",
    "on-surface": "#000000",
    "on-primary": "#FFFFFF",
    "on-menubg": "#FFFFFF",
    "on-navbarbg": "#FFFFFF",

    // Custom brand tokens
    ...customTokens,

    // Charts
    ...chartPalette,

    // Color scales
    ...blueScale,
    ...beigeScale,
    ...yellowScale,
    ...purpleScale,
    ...orangeScale,
  },
};
